(() => {
  const config = document.currentScript;
  if (!config || window.pebQuizPopupBound) return;
  window.pebQuizPopupBound = true;
  let pending;
  let resources;
  let opening = false;
  let status;

  const existingQuiz = () => document.querySelector('[data-quiz-dialog] skin-quiz');
  const loadResource = (tag, attributes) => new Promise((resolve, reject) => {
    const element = Object.assign(document.createElement(tag), attributes);
    const fail = () => { clearTimeout(timeout); element.remove(); reject(new Error('Quiz resource unavailable')); };
    const timeout = setTimeout(fail, 15000);
    element.addEventListener('load', () => { clearTimeout(timeout); resolve(); }, { once: true });
    element.addEventListener('error', fail, { once: true });
    document.head.append(element);
  });

  async function loadQuiz() {
    const source = new URL(config.dataset.quizPopupSource, location.origin);
    if (source.origin !== location.origin) throw new Error('Quiz source must be on this store');
    if (/\/pages\/skin-quiz\/?$/.test(source.pathname) && source.searchParams.get('view') === 'skin-quiz-draft') source.searchParams.set('view', 'skin-quiz');
    if (source.pathname.startsWith('/pages/')) source.pathname = `${(config.dataset.quizRoot || '/').replace(/\/$/, '')}${source.pathname}`;
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) source.searchParams.set('preview_theme_id', preview);
    const response = await fetch(source, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error('Quiz source unavailable');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const section = parsed.querySelector('.skin-quiz-section');
    if (!section?.querySelector('[data-quiz-dialog] skin-quiz')) throw new Error('Quiz source needs Popup mode');
    const host = section.closest('.shopify-section') || section;
    host.querySelectorAll('script, link[rel="stylesheet"]').forEach(element => element.remove());
    host.querySelectorAll('[data-auto-open]').forEach(element => element.removeAttribute('data-auto-open'));
    host.querySelector('.skin-quiz__launcher').style.display = 'none';
    section.style.paddingBlock = '0';
    host.style.display = 'contents';
    host.dataset.quizPopupHost = '';
    if (!resources) resources = Promise.all([
      loadResource('link', { rel: 'stylesheet', href: config.dataset.quizStyle }),
      customElements.get('skin-quiz') ? Promise.resolve() : loadResource('script', { src: config.dataset.quizScript, async: true })
    ]).catch(error => { resources = null; throw error; });
    await resources;
    const adopted = document.adoptNode(host);
    document.body.append(adopted);
    const quiz = adopted.querySelector('skin-quiz');
    if (!quiz?.dialog || !quiz.valid) {
      adopted.remove();
      throw new Error('Quiz configuration unavailable');
    }
    return quiz;
  }

  async function openQuiz(trigger) {
    if (opening) return;
    opening = true;
    const pagePosition = { left: window.scrollX, top: window.scrollY };
    if (status) status.remove();
    status = document.createElement('span');
    status.className = 'sr-only';
    status.setAttribute('role', 'status');
    status.textContent = config.dataset.quizLoading;
    if (trigger?.isConnected) {
      trigger.after(status);
      trigger.setAttribute('aria-busy', 'true');
    } else document.body.append(status);
    try {
      let focusTarget = trigger;
      const root = trigger?.getRootNode();
      const drawer = root instanceof ShadowRoot && root.host.matches('header-sidebar') ? root.host : trigger?.closest('header-sidebar');
      if (drawer?.hide) {
        focusTarget = document.querySelector(`[aria-controls="${CSS.escape(drawer.id)}"]`) || trigger;
        await drawer.hide();
      }
      let quiz = existingQuiz();
      if (!quiz) {
        if (!pending) pending = loadQuiz().catch(error => { pending = null; throw error; });
        quiz = await pending;
      }
      quiz.openDialog(focusTarget || quiz.launcher, pagePosition);
      status.remove();
    } catch (error) {
      status.className = '';
      status.setAttribute('role', 'alert');
      status.textContent = config.dataset.quizError;
    } finally {
      trigger?.removeAttribute('aria-busy');
      opening = false;
    }
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.composedPath().find(node => node instanceof Element && node.matches('a[href]'));
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);
    const quizPage = /\/pages\/skin-quiz\/?$/.test(url.pathname) && (!url.hash || url.hash === '#skin-quiz');
    if ((url.hash !== '#skin-quiz' && !quizPage) || url.origin !== location.origin) return;
    event.preventDefault();
    openQuiz(link);
  }, { capture: true });
  window.addEventListener('hashchange', () => {
    if (location.hash === '#skin-quiz') openQuiz();
  });
  if (location.hash === '#skin-quiz') openQuiz();
})();
